import React, { useEffect, useState } from "react";
import { Col, Container, Row, Breadcrumb, BreadcrumbItem } from "reactstrap";
import "assets/scss/website/app.scss";
import filterIcon from "../../../assets/images/filter.svg";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import SideFilters from "components/Website/SideFilters";
import ResaleSearchService from "services/Website/ResaleSearchService";
import { Link } from "react-router-dom";
import ResaleCard from "components/Website/Cards/ResaleCard";
import { resetFilters } from "store/filter/actions";
import Navbar from "components/Website/Layouts/Navbar";
import Footer from "components/Website/Layouts/Footer";
import Paginator from "./Paginator";
import { SuccessOk } from "configs/statusCode";
import Skeleton from "components/Website/Skeleton";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters } from "store/filter/actions";
import AuthCard from "components/Website/Cards/AuthCard";
import { authenticate, addInterest } from "store/Auth/actions";
import { useTranslation } from "react-i18next";
import CompoundCard from "components/Website/Cards/CompoundCard";
import CompoundsService from "services/Website/CompoundsService";
import "./style.scss";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const ResalesPage = (props) => {
	const { t } = useTranslation();
	const filterData = useSelector((state) => state.filter);
	const AuthData = useSelector((state) => state.Auth);
	const resaleService = new ResaleSearchService();
	const compoundService = new CompoundsService();
	const [loading, setLoading] = useState(false);
	const [modal, setModal] = useState(false);
	const [search, setSearch] = useState(false);
	const [hidden, setHidden] = useState(false);
	const types = ["Resales", "Compounds"];
	const [type, setType] = useState("Resales");
	const [data, setData] = useState([]);
	const [pageOptions, setPageOptions] = useState({
		sizePerPage: 10,
		totalSize: 1,
	});
	const [filtersParams, setFilterParams] = useState(null);

	const dispatch = useDispatch();
	const location = useLocation();

	useEffect(() => {
		if (location?.state?.includes("compounds")) setType("Compounds");
		if (location?.state?.includes("hidden")) setHidden(true);
		if (location?.state === "resales") setType("Resales");
		setSearch("");
		dispatch(appendFilters({ compound: "", resale: "" }));
	}, [location]);

	const formatParamsHandler = (data) => {
		let value = "";
		for (let i = 0; i < data.length; i++) {
			if (i === 0) {
				value = data[i].value;
			} else {
				value = `${value},${data[i].value}`;
			}
		}
		return value;
	};
	// useEffect(() => {
	// 	dispatch(resetFilters());
	// }, []);

	useEffect(() => {
		// debounce solution to reduce request data from api
		const timeoutId = setTimeout(() => {
			setLoading(true);
			// if (filterData.resale?.trim().length)
			// 	document.getElementById("resaleNamme").blur();
			if (filterData.ResaleLocation.length)
				document.getElementById("locationNamme").blur();

			let params = {};
			if (type === "Compounds") {
				if (location?.state?.includes("recommended_compounds"))
					params["compound_type"] = "recommended";
				if (location?.state?.includes("top_compounds"))
					params["compound_type"] = "top";
			}
			if (type === "Resales" && filterData.resale?.trim().length)
				params["keyword"] = filterData.resale.trim();
			if (type === "Compounds" && filterData.compound?.trim().length)
				params["keyword"] = filterData.compound.trim();
			params["budget"] = `${Math.round(filterData.budget[0])}-${Math.round(
				filterData.budget[1]
			)}`;
			params["area_sizs"] = `${Math.round(filterData.size[0])}-${Math.round(
				filterData.size[1]
			)}`;
			if (filterData.floor.length) params["floor"] = filterData.floor.join();
			if (filterData.bedrooms.length)
				params["bedrooms"] = filterData.bedrooms.join();
			if (filterData.bathrooms.length)
				params["bathrooms"] = filterData.bathrooms.join();
			if (
				// filterData.ResaleLocation.length ||
				!!filterData?.ResaleLocation?.value
			)
				params["location"] =
					// filterData.ResaleLocation.trim() ||
					filterData?.ResaleLocation?.value;
			if (filterData.paymentMethods.length)
				params["payment_type"] = filterData.paymentMethods.join();
			if (filterData.categories_ids.length)
				params["category_ids"] = formatParamsHandler(filterData.categories_ids);
			if (filterData.finishingType.length)
				params["finishing_type_ids"] = formatParamsHandler(
					filterData.finishingType
				);
			if (filterData.unitType.length)
				params["unit_type_ids"] = formatParamsHandler(filterData.unitType);
			setFilterParams({ ...params });
		}, 1000);

		return () => clearTimeout(timeoutId);
	}, [filterData, type]);

	useEffect(() => {
		const { type, id } = props.match.params;
		if (id) {
			if (AuthData.token && AuthData.userType === "user") {
				if (type === "view") {
					props.history.push(`/resale-view/${id}`);
				} else if (type === "edit") {
					props.history.push(`/edit-resale/${id}`);
				}
			} else {
				if (type === "view") {
					props.history.push(`/resale-view/${id}`);
					dispatch(authenticate({ navigateTo: `/resale-view/${id}` }));
				} else if (type === "edit") {
					dispatch(authenticate({ navigateTo: `/edit-resale/${id}` }));
					// props.history.push(`/login`, {navigateTo: `/edit-resale/${resale ?.id}` })
				}
			}
		}
	}, []);

	return (
		<React.Fragment>
			<Navbar />
			<div className="websitPages pt-10rem">
				<MetaTags>
					<title>
						{type === "Resales" ? t("Resales Page") : t("Compounds Page")}
					</title>
				</MetaTags>
				<div>
					<div className="container pt-4 pb-5">
						<div className="row filter px-3 px-md-0">
							<div
								className="col-xl-2 col-lg-3 col-md-2 filter-modal-button cursor-pointer"
								onClick={() => setModal(true)}>
								<img src={filterIcon} alt="filterIcon" />
								<span>Filter</span>
							</div>
							<div className="col-xl-8 col-lg-6 col-md-9 filter-search">
								<input
									type="text"
									placeholder="Search by area, Compound"
									name="search"
									value={search}
									onChange={(e) => {
										if (!e.target.value) {
											if (type === "Resales") {
												dispatch(appendFilters({ resale: "" }));
											} else {
												dispatch(appendFilters({ compound: "" }));
											}
										}
										setSearch(e.target?.value);
									}}
								/>
								<i className="fa fa-search" />
							</div>
							<div
								className="col-xl-2 col-lg-3 col-md-5 filter-modal-button cursor-pointer"
								onClick={() => {
									if (type === "Resales") {
										dispatch(appendFilters({ resale: search }));
									} else {
										dispatch(appendFilters({ compound: search }));
									}
								}}>
								<span>Search</span>
							</div>
						</div>
						<div>
							{!hidden && (
								<div className="tabs px-lg-0 px-3">
									{types?.map((ty) => {
										return (
											<p
												className={`tab ${type === ty ? "active" : ""}`}
												key={ty}
												onClick={() => setType(ty)}>
												{t(ty)}
											</p>
										);
									})}
								</div>
							)}

							<Row>
								{!loading ? (
									data.map((item, index) => {
										return (
											<Col xl={4} sm={6} key={index}>
												{type === "Resales" ? (
													<ResaleCard
														resale={item}
														history={props.history}
														loaction={props.loaction}
													/>
												) : (
													<CompoundCard
														compound={item}
														history={props.history}
														loaction={props.loaction}
													/>
												)}
											</Col>
										);
									})
								) : (
									<Skeleton.Resales />
								)}
							</Row>
						</div>
						<Row>
							<Col className="d-flex w-100 justify-content-enter" md={12}>
								<Paginator
									service={type === "Resales" ? resaleService : compoundService}
									pageOptions={pageOptions}
									setData={(data) => {
										setData([...data]);
										setLoading(false);
									}}
									type={type}
									setPageOptions={setPageOptions}
									filtersParams={filtersParams}
									shouldGetData={false}
									setShouldGetData={() => {}}
								/>
							</Col>
						</Row>
						<div className="exploreTopSection inResalesComponents pt-3 pb-5">
							<div className="home-title d-lg-flex justify-content-between align-items-center">
								<div>
									<h2 className="title ">
										<span className="gotham-font">{t("Explore")}</span>
										<span className="bask-font mx-2">
											{t("Resale Properties")}
										</span>
									</h2>
									<p className="gotham-font chooseYourUnit font-size-18">
										Choose Your Unit Now
									</p>
								</div>
								<div>
									<button
										className="btn view-All-link"
										type={"button"}
										onClick={() => setType("Resales")}>
										{t("View All")}
									</button>
								</div>
							</div>
						</div>
						{modal && (
							<SideFilters
								modal={modal}
								toggle={() => setModal(false)}
								loading={loading}
								setLoading={setLoading}
								updateFilterHandler={() => {}}
								history={props?.history}
								type={type === "Resales" ? "Resale" : "Compound"}
							/>
						)}
						{/* <AuthCard modal={modal} setModal={setModal} history={props.history} location={props.location} /> */}
					</div>
				</div>
			</div>
			<Footer />
		</React.Fragment>
	);
};

export default ResalesPage;
